import React from 'react';
import { FeeScheduleView } from '../../../../../../../services/ContractService/types/contractTypes';
import { formatDate } from './formatDate';

/**
 * Date display template
 */
export const DateTemplate: React.FC<{ value: string | null | undefined }> = ({ value }) => (
  <span>{formatDate(value)}</span>
);

// Template functions for grid columns
export const effectiveDateTemplate = (props: FeeScheduleView) => (
  <DateTemplate value={props.effectiveDate} />
);

export const endDateTemplate = (props: FeeScheduleView) => (
  <DateTemplate value={props.endDate} />
);

export default DateTemplate;
